module.exports = __webpack_public_path__ + "static/media/manabi_02_zh.2b5cbdc9.png";